var map = {
	"./App": "3dfd",
	"./App.vue": "3dfd",
	"./assets/cover1.jpg": "240d",
	"./assets/cover2.jpg": "8849",
	"./assets/cover3.jpg": "bdff",
	"./assets/cover4.png": "6fd2",
	"./assets/elena.jpeg": "00db",
	"./assets/joyce.jpeg": "f77f",
	"./assets/logo.png": "cf05",
	"./assets/natacha.jpeg": "9725",
	"./assets/place1.jpg": "0d34",
	"./assets/place2.jpg": "e9e7",
	"./assets/place3.jpg": "fbc3",
	"./assets/place4.jpg": "ab90",
	"./assets/place5.jpg": "aada",
	"./assets/presentation.mp4": "c3b0",
	"./assets/profile.jpg": "3a19",
	"./assets/rea1.jpg": "1bda",
	"./assets/rea10.jpg": "1f36",
	"./assets/rea11.jpg": "40c0",
	"./assets/rea12.jpg": "8912",
	"./assets/rea2.jpg": "563b",
	"./assets/rea3.jpg": "b706",
	"./assets/rea4.jpg": "8b64",
	"./assets/rea5.jpg": "0e90",
	"./assets/rea6.jpg": "5e1d",
	"./assets/rea7.jpg": "f0c7",
	"./assets/rea8.jpg": "a4dd",
	"./assets/rea9.jpg": "1ce8",
	"./assets/team.jpg": "3475",
	"./components/About": "84ba",
	"./components/About.vue": "84ba",
	"./components/Carrousel": "c738",
	"./components/Carrousel.vue": "c738",
	"./components/Contact": "371a",
	"./components/Contact.vue": "371a",
	"./components/Gallery": "39b7",
	"./components/Gallery.vue": "39b7",
	"./components/Header": "0418",
	"./components/Header.vue": "0418",
	"./components/Prices": "d7a3",
	"./components/Prices.vue": "d7a3",
	"./components/PricesList": "dafb",
	"./components/PricesList.vue": "dafb",
	"./components/Profile": "66aa",
	"./components/Profile.vue": "66aa",
	"./components/Team": "5de6",
	"./components/Team.vue": "5de6",
	"./main": "56d7",
	"./main.js": "56d7",
	"./main.scss": "abe2",
	"./styles/colors.scss": "1c98",
	"./styles/responsive.scss": "63f8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8ec";